import { UpsertIncome } from '../../../member-profile/components/UpsertIncome';

const EditIncomePage = () => {
    return <UpsertIncome />;
};

export default EditIncomePage;
